import tree from "../../../components/tree.vue"
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import { emailRule, domainName } from '@/utility/index.js'

export default {
    name: "JurisdictionalCompanies",
    components: { tree, iTable, IPagination },
    data() {
        return {
            formInline: {
                driverNum: '',
                driverName: '',
                name: '',
                driverExpiresType: '',
            },
            StateList: [
                {
                    value: null,
                    label: this.$t('common.all')
                },
                {
                    value: '0',
                    label: this.$t('common.normal')
                },
                {
                    value: '1',
                    label: this.$t('common.nearTime')
                },
                {
                    value: '2',
                    label: this.$t('common.exceedTime')
                }
            ],
            dialogVisible: false,
            height: '550',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columns: [
                {
                    prop: "driverNum",
                    label: this.$t('common.driverNum'),
                    align: "center",
                },
                {
                    prop: "driverName",
                    label: this.$t('common.driverName'),
                    align: "center",
                },
                {
                    prop: "name",
                    label: this.$t('common.companyName'),
                    align: "center",
                },
                {
                    prop: "driverExpires",
                    label: this.$t('GovernmentRegulation.driverExpires'),
                    align: "center",
                },
                {
                    prop: "driverExpiresType",
                    label: this.$t('GovernmentRegulation.driverExpiresType'),
                    align: "center",
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.driverExpiresType === null ? '' : params.row.driverExpiresType === 0 ? 'success' : params.row.driverExpiresType === 1 ? 'warning' : 'danger' }
                        }, params.row.driverExpiresType === null ? '' : params.row.driverExpiresType === 0 ? this.$t('common.normal') : params.row.driverExpiresType === 1 ? this.$t('common.nearTime') : this.$t('common.exceedTime'))
                    }
                },
            ],
            operates: {
                width: 60,
                fixed: "right",
                list: [
                ],
            },
            currentPage: 1, 
            pageSize: 10, 
            total: 1, 
        };
    },
    created() {
        
    },
    mounted() {
        this.getJurisdictional()
    },
    methods: {
        getJurisdictional() {
            let param = {
                jurisdictionNum: sessionStorage.getItem('jurisdictionNum'),
                driverNum: this.formInline.driverNum,
                driverName: this.formInline.driverName,
                name: this.formInline.name,
                driverExpiresType: this.formInline.driverExpiresType,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }
            this.$store.dispatch('JurisdictionalCompanies/GET_GETJURISDICTIONDRIVER', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            })
        },
        onSearch() {
            this.currentPage = 1
            this.getJurisdictional()
        },
        onClear() {
            this.formInline = {
                driverNum: '',
                driverName: '',
                name: '',
                driverExpiresType: '',
            }
            this.getJurisdictional()
        },

        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getJurisdictional();
        },

        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let jurisdictionNum = sessionStorage.getItem("jurisdictionNum")
                    let url = `https://${domainName}/v1/getExportExcel/exportJurisdictionDriver?jurisdictionNum=${jurisdictionNum}&driverNum=${this.formInline.driverNum}&driverName=${this.formInline.driverName}&name=${this.formInline.name}&driverExpiresType=${this.formInline.driverExpiresType}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportJurisdictionDriver?jurisdictionNum=${jurisdictionNum}&driverNum=${this.formInline.driverNum}&driverName=${this.formInline.driverName}&name=${this.formInline.name}&driverExpiresType=${this.formInline.driverExpiresType}`
                    location.href = url
                }
            }
        },
    },
};
 